<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch11"></a><a id="page_12"></a><a href="#/contents#ch11"><b>Death…</b></a></h2>
<p class="noindent"><span>Mark Twain was born in 1835, a year that Halley’s Comet was visible from Earth. As an adult, he predicted he would also die in a year that the comet made an appearance. He did, in 1910.</span></p>
<p class="noindent"><span>Hair and fingernails do not grow after death. Skin recedes, making them appear longer.</span></p>
<p class="noindent"><span>In 1995, inmates on death row in Texas protested because the state had banned smoking in prisons.</span></p>
<p class="noindent"><span>“Old age” hasn’t been allowed on death certificates in the United States as an official cause of death since 1951.</span></p>
<p class="noindent"><span>Thorton’s Mortuary in Atlanta, Georgia, opened the first drive-through funeral parlor in 1968. Mourners drove past a large window, through which they could see the deceased.</span></p>
<p class="noindent"><span>After her husband Albert died in 1861, Queen Victoria slept with a portrait of him on the pillow next to her.</span></p>
<h2 class="h2a"><b>…and Taxes</b></h2>
<p class="noindent"><span>The simplest U.S. tax form (the 1040EZ) has more than 30 pages of instructions.</span></p>
<p class="noindent"><span>The U.S. tax code contains more than 7 million words.</span></p>
<p class="noindent"><span>Many states require people to pay taxes on illegal drug sales.</span></p>
<p class="noindent"><span>In 1798, the United States instituted its first property tax on land, homes…and slaves.</span></p>
<p class="noindent"><span>There are twice as many U.S. tax preparers as police officers.</span></p>
<p class="noindent"><span>In Alabama, there’s a 10¢ tax on playing cards.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter11.vue?282ebce1